<div class="row">
  <div class="col-12">
    <div class="content-header">Course Form</div>
  </div>
</div>
<!-- Basic Inputs start -->
<section id="basic-input">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <!-- <div class="card-header">
					<h4 class="card-title">Basic</h4>
				</div> -->
        <div class="card-content">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <form [formGroup]="courseForm">
                  <fieldset class="form-group">
                    <label for="title"> Title<span class="required_field">*</span></label>
                    <input type="text" class="form-control" formControlName="title" id="title" placeholder="Enter title"
                      [ngClass]="{
                        'is-invalid':
                          courseFormSubmitted && rf.title.invalid,
                        'is-valid':
                          courseFormSubmitted && !rf.title.invalid
                      }" required #title />
                    <div *ngIf="
                        rf.title.touched &&
                        (rf.title.invalid ||
                          rf.title.errors?.required)
                      " class="help-block mt-1 text-danger">
                      <i class="ft-alert-circle align-middle"></i> title
                      is required
                    </div>
                  </fieldset>
                  <fieldset class="form-group">
                    <label for="about">About</label>
                    <input type="text" class="form-control" formControlName="about" id="name" placeholder="Enter about"
                      [ngClass]="{
                        'is-invalid':
                          courseFormSubmitted && rf.about.invalid,
                        'is-valid': courseFormSubmitted && !rf.about.invalid
                      }" required #about />
                  </fieldset>
                  
                  <fieldset class="form-group">
                    <label for="total_fees">Total Fees<span class="required_field">*</span></label>
                    <input type="text" class="form-control" formControlName="total_fees" id="total_fees"
                      placeholder="Enter total fees" [ngClass]="{
                        'is-invalid': courseFormSubmitted && rf.total_fees.invalid,
                        'is-valid': courseFormSubmitted && !rf.total_fees.invalid
                      }" required #total_fees />
                    <div *ngIf="
                        rf.total_fees.touched &&
                        (rf.total_fees.invalid || rf.total_fees.errors?.required)
                      " class="help-block mt-1 text-danger">
                      <i class="ft-alert-circle align-middle"></i>total fees is
                      required
                    </div>
                  </fieldset>
                  <fieldset class="form-group">
                    <label>Min Fees</label>
                    <input type="text" class="form-control" formControlName="min_fees" id="min_fees"
                      placeholder="Enter min fees" required #min_fees />
                    <div *ngIf="
                        rf.min_fees.touched &&
                        (rf.min_fees.invalid || rf.min_fees.errors?.required)
                      " class="help-block mt-1 text-danger">
                      <i class="ft-alert-circle align-middle"></i>min fees is
                      required
                    </div>
                  </fieldset>
                  <fieldset class="form-group">
                    <label>Max Fees</label>
                    <input type="text" class="form-control" formControlName="max_fees" id="max_fees"
                      placeholder="Enter max fees" required #max_fees />
                    <div *ngIf="
                        rf.max_fees.touched &&
                        (rf.max_fees.invalid || rf.max_fees.errors?.required)
                      " class="help-block mt-1 text-danger">
                      <i class="ft-alert-circle align-middle"></i>max fees is
                      required
                    </div>
                  </fieldset>
                  <fieldset class="form-group">
                    <label>Service And Offer</label>
                    <input type="text" class="form-control" formControlName="serviceandoffer" id="serviceandoffer"
                      placeholder="Enter service and offer"/>
                  </fieldset>
                  <fieldset class="form-group">
                    <label>course_type<span class="required_field">*</span></label>
                      <ng-select [items]="course_type_List" bindLabel="displayname" bindValue="_id"
                      placeholder="Select Course type" [(ngModel)]="selected_course_type"
                      [ngModelOptions]="{ standalone: true }" (change)="getCourseTypeId($event)">
                    </ng-select>
                  </fieldset>
                  <fieldset class="form-group">
                    <label>instructor<span class="required_field">*</span></label>
                    <ng-select [items]="fullpart_employee_list" bindLabel="name" bindValue="Empid"
                      placeholder="Select instructor" [(ngModel)]="selected_instructor"
                      [ngModelOptions]="{ standalone: true }" (change)="getinstructorId($event)">
                    </ng-select>
                  </fieldset>
                  <fieldset class="form-group">
                    <label>language<span class="required_field">*</span></label>
                    <input type="text" class="form-control" formControlName="language" id="language"
                      placeholder="Enter language"/>
                  </fieldset>
                  <fieldset class="form-group">
                    <label for="preliminary">preliminary</label>
                    <textarea formControlName="preliminarye" id="hidden-label-form-6" rows="2" class="form-control"
                      name="comment2" placeholder="Enter preliminary"></textarea>
                   
                  </fieldset>
                  <fieldset class="form-group">
                    <label>Benifits</label>
                    <textarea formControlName="benifits" id="hidden-label-form-6" rows="4" class="form-control"
                      name="comment2" placeholder="Enter benifits" ></textarea>
                  </fieldset>
                  <fieldset class="form-group">
                    <label>Learning Audience</label>
                    <textarea formControlName="learning_audience" id="hidden-label-form-6" rows="4" class="form-control"
                      name="comment2" placeholder="Enter learning audience" ></textarea>
                  </fieldset>
                  <fieldset class="form-group">
                    <label>Outcome</label>
                    <textarea formControlName="outcome" id="hidden-label-form-6" rows="4" class="form-control"
                      name="comment2" placeholder="Enter outcome" ></textarea>
                  </fieldset>
                  <fieldset class="form-group">
                    <label>Objective</label>
                    <textarea formControlName="objective" id="hidden-label-form-6" rows="4" class="form-control"
                      name="comment2" placeholder="Enter objective" ></textarea>
                  </fieldset>
                  <fieldset class="form-group">
                    <label>promotional video</label>
                    <textarea formControlName="promotional_video" id="hidden-label-form-6" rows="4" class="form-control"
                      name="comment2" placeholder="Enter promotional video" ></textarea>
                  </fieldset>
                  <fieldset class="form-group">
                    <label>Announcements</label>
                    <textarea name="announcements" class="form-control" id="announcements" placeholder="Enter Announcements"  formControlName="announcements" cols="30" rows="4"></textarea>
                  </fieldset>
                  <fieldset class="form-group">
                    <label for="notes">notes</label>
                    <textarea formControlName="notes" id="hidden-label-form-6" rows="2" class="form-control"
                      name="comment2" placeholder="Enter notes" ></textarea>
                  </fieldset>
                  <fieldset class="form-group">
                    <label for="admin_notes">Admin Notes</label>
                    <textarea formControlName="admin_notes" id="hidden-label-form-6" rows="2" class="form-control"
                      name="comment2" placeholder="Enter admin_notes" ></textarea>
                    
                  </fieldset>

                </form>
              </div>
              <div class="col-md-6">
                <form [formGroup]="courseForm">
                 
                  <fieldset class="form-group">
                    <label>mode<span class="required_field">*</span></label>
                    <ng-select [items]="mode_List" bindLabel="displayname" bindValue="_id"
                      placeholder="Select mode" [(ngModel)]="selected_mode"
                      [ngModelOptions]="{ standalone: true }" (change)="getModeId($event)">
                    </ng-select>
                  </fieldset>
                  <fieldset class="form-group">
                    <label>offers<span class="required_field">*</span></label>
                    <ng-select [items]="offers_list" bindLabel="displayname" bindValue="_id"
                      placeholder="Select offers" [(ngModel)]="selected_discount"
                      [ngModelOptions]="{ standalone: true }" (change)="getDiscountId($event)">
                    </ng-select>
                  </fieldset>
                  <fieldset class="form-group">
                    <label>proof readers<span class="required_field">*</span></label>
                    <ng-select [items]="fullpart_employee_list" bindLabel="name" bindValue="Empid"
                      placeholder="Select proof readers" [(ngModel)]="selected_proofread"
                      [ngModelOptions]="{ standalone: true }" (change)="getProofreadId($event)">
                    </ng-select>
                  </fieldset>
                  <fieldset class="form-group">
                    <label>publishers<span class="required_field">*</span></label>
                    <ng-select [items]="fullpart_employee_list" bindLabel="name" bindValue="Empid"
                      placeholder="Select publishers" [(ngModel)]="selected_publisher"
                      [ngModelOptions]="{ standalone: true }" (change)="getPublisherId($event)">
                    </ng-select>
                  </fieldset>
                  <fieldset class="form-group">
                    <label>last published by<span class="required_field">*</span></label>
                    <ng-select [items]="fullpart_employee_list" bindLabel="name" bindValue="Empid"
                      placeholder="Select last publishers" [(ngModel)]="selected_last_publisher"
                      [ngModelOptions]="{ standalone: true }" (change)="getLastPublisherId($event)">
                    </ng-select>
                  </fieldset>
                  <fieldset class="form-group">
                    <label>projects<span class="required_field">*</span></label>
                    <ng-select [items]="project_list" bindLabel="name" bindValue="_id"
                      placeholder="Select project" [(ngModel)]="selected_project"
                      [ngModelOptions]="{ standalone: true }" (change)="getProjectId($event)">
                    </ng-select>
                  </fieldset>
                  <fieldset class="form-group">
                    <label>resources<span class="required_field">*</span></label>
                    <ng-select [items]="resource_list" bindLabel="content" bindValue="id"
                    placeholder="Select last publishers" [(ngModel)]="selected_resource"
                    [ngModelOptions]="{ standalone: true }" (change)="getResourceId($event)">
                  </ng-select>
                  </fieldset>
                  <fieldset class="form-group">
                    <label>duration<span class="required_field">*</span></label>
                    <ng-select [items]="duration_List" bindLabel="displayname" bindValue="_id"
                      placeholder="Select Variation" [(ngModel)]="selected_duration"
                      [ngModelOptions]="{ standalone: true }" (change)="getDurationId($event)">
                    </ng-select>
                  </fieldset>
                  <fieldset class="form-group">
                    <label>level<span class="required_field">*</span></label>
                    <ng-select [items]="level_List" bindLabel="displayname" bindValue="_id"
                      placeholder="Select level" [(ngModel)]="selected_level"
                      [ngModelOptions]="{ standalone: true }" (change)="getLevelId($event)">
                    </ng-select>
                  </fieldset>
                  <fieldset class="form-group">
                    <label>grading</label>
                    <input type="text" class="form-control" formControlName="grading" id="grading"
                      placeholder="Enter grading"/>
                  </fieldset>
                  <fieldset class="form-group">
                    <label>certification</label>
                    <input type="text" class="form-control" formControlName="certification" id="certification"
                      placeholder="Enter certification"/>
                  </fieldset>
                  <fieldset class="form-group">
                    <label>published_datetime</label>
                    <input type="datetime-local" class="form-control" formControlName="published_datetime" id="published_datetime"
                      placeholder="Enter published_datetime"/>
                  </fieldset>
                  <fieldset class="form-group">
                    <label>version</label>
                    <input type="text" class="form-control" formControlName="version" id="version"
                      placeholder="Enter version"/>
                  </fieldset>
                  <fieldset class="form-group">
                    <label>LMS<span class="required_field">*</span></label>
                    <ng-select [items]="lmsData" bindLabel="title" bindValue="id"
                      placeholder="Select LMS ID" [multiple]="true"
                      [closeOnSelect]="false"  [(ngModel)]="this.selectedLms"
                      [ngModelOptions]="{ standalone: true }" (change)="getLmsV1ById($event)">
                    </ng-select>
                  </fieldset>
                 
                  <fieldset class="form-group">
                    <label>course category<span class="required_field">*</span></label>
                    <ng-select [items]="categoryList" bindLabel="displayname" bindValue="_id"
                      placeholder="Select Course Interest" [(ngModel)]="selectedCategory"
                      [ngModelOptions]="{ standalone: true }" (change)="getCategoryId($event)">
                    </ng-select>
                  </fieldset>
                  <fieldset class="form-group">
                    <label>course skills<span class="required_field">*</span></label>
                    <ng-select [items]="tagsList" bindLabel="displayname" bindValue="_id" [multiple]="true"
                      [closeOnSelect]="false" placeholder="Select Skill" [(ngModel)]="selectedTag"
                      [ngModelOptions]="{ standalone: true }" (change)="getTagsId($event)">
                    </ng-select>
                  </fieldset>
                  <fieldset class="form-group">
                    <label>Variation<span class="required_field">*</span></label>
                    <ng-select [items]="variationList" bindLabel="displayname" bindValue="_id"
                      placeholder="Select Variation" [(ngModel)]="selectedVariation"
                      [ngModelOptions]="{ standalone: true }" (change)="getVariationId($event)">
                    </ng-select>
                  </fieldset>
                  <fieldset class="form-group">
                    <label>course tags<span class="required_field">*</span></label>
                    <ng-select [items]="courseTagsList" bindLabel="displayname" bindValue="_id"
                      placeholder="Select Course Tags" [(ngModel)]="selectedCourseTag"
                      [ngModelOptions]="{ standalone: true }" (change)="getCourseTagId($event)">
                    </ng-select>
                  </fieldset>
                  <fieldset class="form-group">
                    <label>Batch<span class="required_field">*</span></label>
                    <ng-select [items]="batchList" bindLabel="name" bindValue="_id" placeholder="Select Batch"
                      [(ngModel)]="selectedBatch" [ngModelOptions]="{ standalone: true }" (change)="getBatchId($event)">
                    </ng-select>
                  </fieldset>
                  <fieldset class="form-group">
                    <label class="form-control-label" for="Employeetype">
                     Category Tags<span class="required_field">*</span>
                    </label>
                    <ng-select
                      [items]="category_tags_list"
                      bindLabel="displayname"
                      bindValue="_id"
                      placeholder="Select Category Tags"
                      [(ngModel)]="selected_category_tags"
                      [ngModelOptions]="{ standalone: true }"
                      (change)="getCategoryTagsId($event)"
                    >
                    </ng-select>
                  </fieldset>
                  <fieldset class="form-group">
                    <label>Published Web<span class="required_field">*</span></label>
                    <ng-select [items]="publish_List" bindLabel="displayname" bindValue="_id"
                      placeholder="Select Published Web" [(ngModel)]="selected_publish_web"
                      [ngModelOptions]="{ standalone: true }" (change)="getPublishWebId($event)">
                    </ng-select>
                  </fieldset>
                  <fieldset class="form-group">
                    <label>Published App<span class="required_field">*</span></label>
                    <ng-select [items]="publish_List" bindLabel="displayname" bindValue="_id"
                      placeholder="Select Published App" [(ngModel)]="selected_publish_app"
                      [ngModelOptions]="{ standalone: true }" (change)="getPublishAppId($event)">
                    </ng-select>
                  </fieldset>
                  <fieldset class="form-group">
                    <input type="file" class="form-control" formControlName="image" required
                      (change)="onSelectFile($event)" />
                  </fieldset>
                  <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mt-3 mt-sm-2">
                    <button type="submit" class="btn btn-primary mb-2 mb-sm-0 mr-sm-2" 
                      (click)="submitCourse()">
                      Submit
                    </button>
                    <button type="reset" class="btn btn-secondary" (click)="back()">
                      Cancel
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>